import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from '@/middleware/auth'

import UserLogin from "@/components/UserLogin.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ResetPassword from "@/components/ResetUserPassword.vue";
import PageNotFound from "@/components/UserPageNotFound.vue";
import ServerErrorPage from "@/components/UserPageServerError.vue";
import AuthorizedErrorPage from "@/components/UserPageAuthorized.vue";
import UserDashboard from "@/components/UserDashboard.vue";
import UserProfile from "@/components/users/Profile.vue";
import ChangePassword from "@/components/users/ChangePassword.vue";

import UsersAccess from "@/components/user_access/Index";
import routesUsersAccess from "@/components/user_access/routes";

import RoleAccess from "@/components/role/Index";
import routesRoleAccess from "@/components/role/routes";

import PermissionAccess from "@/components/permission/Index";
import routesPermissionAccess from "@/components/permission/routes";

import PermissionRoleAccess from "@/components/permission_role/Index";
import routesPermissionRoleAccess from "@/components/permission_role/routes";

import CompanyAccess from "@/components/company/Index";
import routesCompanyAccess from "@/components/company/routes";

import CompanyOmsAccess from "@/components/oms/company/Index";
import routesCompanyOmsAccess from "@/components/oms/company/routes";

import CompanyFulfillmentOmsAccess from "@/components/oms/company_fulfillments/Index";
import routesCompanyFulfillmentOmsAccess from "@/components/oms/company_fulfillments/routes";

import UserOmsAccess from "@/components/oms/users/Index";
import routesUserOmsAccess from "@/components/oms/users/routes";

import FulfillmentOmsAccess from "@/components/oms/fulfillment/Index";
import routesFulfillmentOmsAccess from "@/components/oms/fulfillment/routes";

import UserDashboardBilling from "@/components/billing/UserDashboardBilling.vue";
import BillingCompanyGroup from "@/components/billing/company_group/Index";
import routesBillingCompanyGroup from "@/components/billing/company_group/routes";

import BillingCustomer from "@/components/billing/customers/Index";
import routesBillingCustomer from "@/components/billing/customers/routes";

import BillingFulfillment from "@/components/billing/fulfillment/Index";
import routesBillingFulfillment from "@/components/billing/fulfillment/routes";

import BillingWarehouseSystemCode from "@/components/billing/warehouse_system_code/Index";
import routesBillingWarehouseSystemCode from "@/components/billing/warehouse_system_code/routes";

import BillingBmCodelkup from "@/components/billing/bm_codelkup/Index";
import routesBillingBmCodelkup from "@/components/billing/bm_codelkup/routes";

import BillingCliMasterWarehouse from "@/components/billing/cli_master_warehouse/Index";
import routesBillingCliMasterWarehouse from "@/components/billing/cli_master_warehouse/routes";

import BillingCliMasterCustomer from "@/components/billing/cli_master_customer/Index";
import routesBillingCliMasterCustomer from "@/components/billing/cli_master_customer/routes";

import BillingCliRateHeader from "@/components/billing/cli_rate/Index";
import routesCliRateHeaderAccess from "@/components/billing/cli_rate/routes";

import BillingCliBilling from "@/components/billing/cli/Index";
import routesCliBillingAccess from "@/components/billing/cli/routes";

import BillingFulfillmentCML from "@/components/billing_cml/fulfillment/Index";
import routesBillingFulfillmentCML from "@/components/billing_cml/fulfillment/routes";

import BillingCmlMasterCustomer from "@/components/billing_cml/customer/Index";
import routesBillingCmlMasterCustomer from "@/components/billing_cml/customer/routes";

import BillingCmlRates from "@/components/billing_cml/rate/Index";
import routesBillingCmlRates from "@/components/billing_cml/rate/routes";

import BillingCmlRatebase from "@/components/billing_cml/ratebase/Index";
import routesBillingCmlRatebase from "@/components/billing_cml/ratebase/routes";

import BillingCmlBmCode from "@/components/billing_cml/bm-code-lkup/Index";
import routesBillingCmlBmCode from "@/components/billing_cml/bm-code-lkup/routes";

import BillingCmlTarifMaster from "@/components/billing_cml/tarif/Index";
import routesBillingCmlTarifMaster from "@/components/billing_cml/tarif/routes";

import BillingCmlMasterLocations from "@/components/billing_cml/master_locations/Index";
import routesBillingCmlMasterLocations from "@/components/billing_cml/master_locations/routes";

import BillingCmlHeader from "@/components/billing_cml/billing/Index";
import routesCmlBillingAccess from "@/components/billing_cml/billing/routes";

import SalesForceOpportunityBilling from "@/components/sales_force/opportunity_billing/Index";
import routesSalesForceOpportunityBillingAccess from "@/components/sales_force/opportunity_billing/routes";

import WaMasterPhoneNumberAccess from "@/components/whatsapp/master_phone_number/Index";
import routesWaMasterPhoneNumber from "@/components/whatsapp/master_phone_number/routes";

import WaMessagerAccess from "@/components/whatsapp/message_data/Index";
import routesWaMessage from "@/components/whatsapp/message_data/routes";

import BillingCmlStorageEstimation from "@/components/billing_cml/storage_estimation/Index";
import routesCmlStorageEstimation from "@/components/billing_cml/storage_estimation/routes";

import BillingCmlBmWmsCode from "@/components/billing_cml/bm_code/Index";
import routesCmlBmWmsCode from "@/components/billing_cml/bm_code/routes";

import BlujayChainAccess from "@/components/blujay/chain/Index";
import routesBlujayChainAccess from "@/components/blujay/chain/routes";

import BlujayGsoftAccess from "@/components/blujay/gsoft/Index";
import routesBlujayGsoftAccess from "@/components/blujay/gsoft/routes";


import FluxOmsMasterSKU from "@/components/flux_oms/master_sku/Index";
import FluxOmsMasterSKURoute from "@/components/flux_oms/master_sku/routes";

import FluxOmsSO from "@/components/flux_oms/so/Index";
import FluxOmsSORoute from "@/components/flux_oms/so/routes";

import FluxOmsPO from "@/components/flux_oms/po/Index";
import FluxOmsPORoute from "@/components/flux_oms/po/routes";

import FluxOmsASN from "@/components/flux_oms/asn/Index";
import FluxOmsASNRoute from "@/components/flux_oms/asn/routes";

import FluxOmsVendor from "@/components/flux_oms/vendor/Index";
import FluxOmsVendorRoute from "@/components/flux_oms/vendor/routes";


import FluxOmsInterface from "@/components/flux_oms/interface/Index";
import FluxOmsInterfaceRoute from "@/components/flux_oms/interface/routes";

import FluxOmsInventory from "@/components/flux_oms/InventoryView.vue";
import FluxOmsInventorySummary from "@/components/flux_oms/InventorySummary.vue";


import BlujayBcaMasterLocation from "@/components/blujay_bca/master_location/Index";
import BlujayBcaMasterLocationRoute from "@/components/blujay_bca/master_location/routes";

import BlujayBcaUserLocation from "@/components/blujay_bca/user_location/Index";
import BlujayBcaUserLocationRoute from "@/components/blujay_bca/user_location/routes";

import BlujayBcaTransaction from "@/components/blujay_bca/transactions/Index";
import BlujayBcaTransactionRoute from "@/components/blujay_bca/transactions/routes";

import CeisaSystemCode from "@/components/exim/ceisa/system_code/Index";
import CeisaSystemCodeRoute from "@/components/exim/ceisa/system_code/routes";

import CeisaClientLogin from "@/components/exim/ceisa/client_login/Index";
import CeisaClientLoginRoute from "@/components/exim/ceisa/client_login/routes";

import CeisaPpjk from "@/components/exim/ceisa/ppjk/Index";
import CeisaPpjkRoute from "@/components/exim/ceisa/ppjk/routes";

import CeisaBarangImpor from "@/components/exim/ceisa/barang_impor/Index";
import CeisaBarangImporRoute from "@/components/exim/ceisa/barang_impor/routes";

import CeisaMasterCustomer from "@/components/exim/ceisa/master_customer/Index";
import CeisaMasterCustomerRoute from "@/components/exim/ceisa/master_customer/routes";

import CeisaHsCode from "@/components/exim/ceisa/hs_code/Index";
import CeisaHsCodeRoute from "@/components/exim/ceisa/hs_code/routes";

import SalesSurvey from "@/components/sales_survey/Index";
import SalesSurveyRoute from "@/components/sales_survey/routes";

import BillingMapping from "@/components/billing_mapping/Index";
import BillingMappingRoute from "@/components/billing_mapping/routes";

import whMonitoringRoute from '@/components/wh_monitoring/routes';
import whMonitoringIndex from '@/components/wh_monitoring/Index';

import billingEximMasterFreightRoute from '@/components/exim/billing/master_freight/routes';
import billingEximMasterFreightIndex from '@/components/exim/billing/master_freight/Index';

import billingEximBillHeaderRoute from '@/components/exim/billing/bill_header/routes';
import billingEximBillHeaderIndex from '@/components/exim/billing/bill_header/Index';

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "UserLogin",
    component: UserLogin
  },
  {
    path: "/forgot-password",
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/reset-password/:email/:token",
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "ResetPassword",
    component: ResetPassword,
    props: true
  },
  {
    path: '/server-error',
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "ServerErrorPage",
    component: ServerErrorPage
  },
  {
    path: '/authorized-error',
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "AuthorizedErrorPage",
    component: AuthorizedErrorPage
  },
  {
    path: '/page-not-found',
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "PageNotFound",
    component: PageNotFound
  },
  {
    path: '*',
    meta: {
      title: "Linc Middleware"
    },
    name: "PageNotFoundArea",
    component: PageNotFound
  },
  {
    path: '/dashboard',
    meta: {
      title: "Linc Middleware",
    },
    name: "UserDashboard",
    component: UserDashboard
  },
  {
    path: '/profile',
    meta: {
      title: "Linc Middleware",
    },
    name: "UserProfile",
    component: UserProfile
  },
  {
    path: '/change-password',
    meta: {
      title: "Linc Middleware",
    },
    name: "ChangePassword",
    component: ChangePassword
  },

  /** user access */

  {
    path: '/user-access',
    meta: {
      title: "User Access",
    },
    children:routesUsersAccess,
    component: UsersAccess
  },

  /** role */

  {
    path: '/role',
    meta: {
      title: "Role Access",
    },
    children:routesRoleAccess,
    component: RoleAccess
  },

  /** permission */

  {
    path: '/permission',
    meta: {
      title: "Permission Access",
    },
    children:routesPermissionAccess,
    component: PermissionAccess
  },

  /** permission role */

  {
    path: '/rolpermis',
    meta: {
      title: "Permission Role Access",
    },
    children:routesPermissionRoleAccess,
    component: PermissionRoleAccess
  },

  /** permission role */

  {
    path: '/company',
    meta: {
      title: "Company Access",
    },
    children:routesCompanyAccess,
    component: CompanyAccess
  },

  {
    path: '/company-oms',
    meta: {
      title: "Company OMS Access",
    },
    children:routesCompanyOmsAccess,
    component: CompanyOmsAccess
  },

  {
    path: '/fulfillment-oms',
    meta: {
      title: "Fulfillment OMS Access",
    },
    children:routesFulfillmentOmsAccess,
    component: FulfillmentOmsAccess
  },

  {
    path: '/company-fulfillment-oms',
    meta: {
      title: "Company Fulfillment OMS Access",
    },
    children:routesCompanyFulfillmentOmsAccess,
    component: CompanyFulfillmentOmsAccess
  },

  {
    path: '/user-oms',
    meta: {
      title: "User OMS Access",
    },
    children:routesUserOmsAccess,
    component: UserOmsAccess
  },

  /** billing */
  {
    path: '/dashboard-billing',
    meta: {
      title: "Billing",
    },
    name: "UserDashboardBilling",
    component: UserDashboardBilling
  },

  {
    path: '/billing-company-group',
    meta: {
      title: "Billing",
    },
    children:routesBillingCompanyGroup,
    component: BillingCompanyGroup
  },
  {
    path: '/billing-customers',
    meta: {
      title: "Billing",
    },
    children:routesBillingCustomer,
    component: BillingCustomer
  },
  {
    path: '/billing-fulfillment',
    meta: {
      title: "Fulfillment",
    },
    children:routesBillingFulfillment,
    component: BillingFulfillment
  },
  {
    path: '/billing-warehouse-system-code',
    meta: {
      title: "Warehouse System Code",
    },
    children:routesBillingWarehouseSystemCode,
    component: BillingWarehouseSystemCode
  },
  {
    path: '/billing-bm-code-lkup',
    meta: {
      title: "BM Code",
    },
    children:routesBillingBmCodelkup,
    component: BillingBmCodelkup
  },
  {
    path: '/billing-cli-master-warehouse',
    meta: {
      title: "CLI Master Warehouse",
    },
    children:routesBillingCliMasterWarehouse,
    component: BillingCliMasterWarehouse
  },
  {
    path: '/billing-cli-master-customer',
    meta: {
      title: "CLI Master Customer",
    },
    children:routesBillingCliMasterCustomer,
    component: BillingCliMasterCustomer
  },
  {
    path: '/billing-cli-rate',
    meta: {
      title: "CLI Rate",
    },
    children:routesCliRateHeaderAccess,
    component: BillingCliRateHeader
  },
  {
    path: '/billing-cli-billing',
    meta: {
      title: "CLI Billing",
    },
    children:routesCliBillingAccess,
    component: BillingCliBilling
  },
  /**
   * Billing CML
   */

  {
    path: '/billing-cml/master-warehouse',
    meta: {
      title: "Billing Master Fulfillment CML",
    },
    children:routesBillingFulfillmentCML,
    component: BillingFulfillmentCML
  },
  {
    path: '/billing-cml/master-customer',
    meta: {
      title: "CML Master Customer",
    },
    children:routesBillingCmlMasterCustomer,
    component: BillingCmlMasterCustomer
  },
  {
    path: '/billing-cml/rates',
    meta: {
      title: "CML Rates",
    },
    children:routesBillingCmlRates,
    component: BillingCmlRates
  },
  {
    path: '/billing-cml/ratebase',
    meta: {
      title: "CML Ratebase",
    },
    children:routesBillingCmlRatebase,
    component: BillingCmlRatebase
  },
  {
    path: '/billing-cml/bm-code-lkup',
    meta: {
      title: "CML BM Code",
    },
    children:routesBillingCmlBmCode,
    component: BillingCmlBmCode
  },
  {
    path: '/billing-cml/master-tarif',
    meta: {
      title: "CML Tarif",
    },
    children:routesBillingCmlTarifMaster,
    component: BillingCmlTarifMaster
  },


  {
    path: '/flux-oms/master-sku',
    meta: {
      title: "Master SKU",
    },
    children:FluxOmsMasterSKURoute,
    component: FluxOmsMasterSKU
  },


  {
    path: '/flux-oms/so-outbound',
    meta: {
      title: "Flux OMS SO - Outbond",
    },
    children:FluxOmsSORoute,
    component: FluxOmsSO
  },

  {
    path: '/flux-oms/po-inbound',
    meta: {
      title: "Flux OMS PO - Inbond",
    },
    children:FluxOmsPORoute,
    component: FluxOmsPO
  },


  {
    path: '/flux-oms/asn-inbound',
    meta: {
      title: "Flux OMS ASN - Inbond",
    },
    children:FluxOmsASNRoute,
    component: FluxOmsASN
  },

  {
    path: '/flux-oms/vendor',
    meta: {
      title: "Flux OMS Vendor",
    },
    children:FluxOmsVendorRoute,
    component: FluxOmsVendor
  },

  {
    path: '/flux-oms/interface',
    meta: {
      title: "Flux OMS Interface",
    },
    children:FluxOmsInterfaceRoute,
    component: FluxOmsInterface
  },

  {
    path: '/flux-oms/inventory',
    meta: {
      title: "Flux OMS inventory",
    },
    component: FluxOmsInventory
  },

  {
    path: '/flux-oms/inventory-summary',
    meta: {
      title: "Flux OMS inventory Summary",
    },
    component: FluxOmsInventorySummary
  },

  {
    path: '/billing-cml/master-locations',
    meta: {
      title: "CML Master Locations",
    },
    children:routesBillingCmlMasterLocations,
    component: BillingCmlMasterLocations
  },
  {
    path: '/billing-cml/billing',
    meta: {
      title: "CML Billing",
    },
    children:routesCmlBillingAccess,
    component: BillingCmlHeader
  },
  {
    path: '/sales_force/opportunity_billing',
    meta: {
      title: "Sales Force Opportunity Billing",
    },
    children:routesSalesForceOpportunityBillingAccess,
    component: SalesForceOpportunityBilling
  },
  {
    path: '/billing-cml/storage-estimation',
    meta: {
      title: "CML Billing",
    },
    children:routesCmlStorageEstimation,
    component: BillingCmlStorageEstimation
  },
  {
    path: '/billing-cml/wms-code',
    meta: {
      title: "CML Billing",
    },
    children:routesCmlBmWmsCode,
    component: BillingCmlBmWmsCode
  },

  /**
   * Whatsapp
   */
  {
    path: '/whatsapp/master-phone-number',
    meta: {
      title: "Master Phone Number Access",
    },
    children:routesWaMasterPhoneNumber,
    component:WaMasterPhoneNumberAccess 
  },
  {
    path: '/whatsapp/message-data',
    meta: {
      title: "WA Message Data",
    },
    children:routesWaMessage,
    component:WaMessagerAccess 
  },

  /**
   * Blujay
   */
  {
    path: '/blujay/chain',
    meta: {
      title: "Blujay Chain Access",
    },
    children:routesBlujayChainAccess,
    component:BlujayChainAccess 
  },

  {
    path: '/blujay/gsoft',
    meta: {
      title: "Blujay Gsoft Access",
    },
    children:routesBlujayGsoftAccess,
    component:BlujayGsoftAccess 
  },
 

  /**
   * Blujay Bca
   */
  {
    path: '/blujay-bca/master-location',
    meta: {
      title: "Blujay Bca Master Location",
    },
    children:BlujayBcaMasterLocationRoute,
    component:BlujayBcaMasterLocation 
  },
  {
    path: '/blujay-bca/user-mapping-location',
    meta: {
      title: "Blujay Bca User Location",
    },
    children:BlujayBcaUserLocationRoute,
    component:BlujayBcaUserLocation 
  },
  {
    path: '/blujay-bca/transactions',
    meta: {
      title: "Blujay Bca Transaction",
    },
    children:BlujayBcaTransactionRoute,
    component:BlujayBcaTransaction
  },
  
 

  /**
   * EXIM - CEISA
   */
  {
    path: '/exim/ceisa/system-code',
    meta: {
      title: "CEISA System Code",
    },
    children:CeisaSystemCodeRoute,
    component:CeisaSystemCode
  },
  {
    path: '/exim/ceisa/hs-code',
    meta: {
      title: "CEISA System Code",
    },
    children:CeisaHsCodeRoute,
    component:CeisaHsCode
  },
  {
    path: '/exim/ceisa/client-login',
    meta: {
      title: "CEISA Client Login",
    },
    children:CeisaClientLoginRoute,
    component:CeisaClientLogin
  },
  {
    path: '/exim/ceisa/ppjk',
    meta: {
      title: "CEISA PPJK",
    },
    children:CeisaPpjkRoute,
    component:CeisaPpjk
  },
  {
    path: '/exim/ceisa/dokumen-pabean',
    meta: {
      title: "CEISA Dokumen Pabean",
    },
    children:CeisaBarangImporRoute,
    component:CeisaBarangImpor
  },
  {
    path: '/exim/ceisa/customer',
    meta: {
      title: "CEISA Master Customer",
    },
    children:CeisaMasterCustomerRoute,
    component:CeisaMasterCustomer
  },
  {
    path: '/sales-survey',
    meta: {
      title: "Sales Survey",
    },
    children:SalesSurveyRoute,
    component:SalesSurvey
  },
  {
    path: '/billing-mapping',
    meta: {
      title: "Billing Mapping",
    },
    children:BillingMappingRoute,
    component:BillingMapping
  },
  {
    path:'/wh-monitoring',
    children:whMonitoringRoute,
    component:whMonitoringIndex
  },
  {
    path:'/billing/exim/master-freight',
    children:billingEximMasterFreightRoute,
    component:billingEximMasterFreightIndex
  },
  {
    path:'/billing/exim/transaction',
    children:billingEximBillHeaderRoute,
    component:billingEximBillHeaderIndex
  }
  
];

const router = new VueRouter({
  mode: "history",
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  if (to.name == 'UserLogin' && isLoggedIn() || to.name == 'ForgotPassword' && isLoggedIn() || to.name == 'ResetPassword' && isLoggedIn()) {

    next({ path: '/dashboard' , prevRoute:from })

  }
  else if (!to.meta.allowAnonymous && !isLoggedIn()) {
    next({
      path: '/',
      prevRoute:from,
      query: { redirect: to.fullPath }
    })
  }
  else {
    next({prevRoute:from})
  }
});


export default router;
